<template>
  <div
    class="reaction"
    :class="{'white': $store.state.slide.textColour == '#ffffff', 'n-p': !$store.state.slide.isHaha && !$store.state.slide.isHeart && !$store.state.slide.isQuestion && !$store.state.slide.isLike && !$store.state.slide.isDislike}"
  >
    <div class="item-reaction" v-show="$store.state.slide.isHeart">
      <div
        class="item-reaction-bg"
        :class="{'white': $store.state.slide.textColour == '#ffffff','black': $store.state.slide.textColour == '#313131'}"
      >
        <button class="icobutton icobutton--heart" ref="elHeart" :class="{active: isHeart}">
          <span class="fa fa-heart fa-fw" ref="iconHeart" />
        </button>
      </div>
    </div>
    <div class="item-reaction" v-show="$store.state.slide.isHaha">
      <div
        class="item-reaction-bg"
        :class="{'white': $store.state.slide.textColour == '#ffffff','black': $store.state.slide.textColour == '#313131'}"
      >
        <button class="icobutton icobutton--haha" ref="elHaha" :class="{active: isHaha}">
          <span class="fas fa-grin-squint fa-fw" ref="iconHaha" />
        </button>
      </div>
    </div>
    <div class="item-reaction" v-show="$store.state.slide.isLike">
      <div
        class="item-reaction-bg"
        :class="{'white': $store.state.slide.textColour == '#ffffff','black': $store.state.slide.textColour == '#313131'}"
      >
        <button class="icobutton icobutton--like" ref="elLike" :class="{active: isLike}">
          <span class="fa fa-thumbs-up fa-fw" ref="iconLike" />
        </button>
      </div>
    </div>
    <div class="item-reaction" v-show="$store.state.slide.isDislike">
      <div
        class="item-reaction-bg"
        :class="{'white': $store.state.slide.textColour == '#ffffff','black': $store.state.slide.textColour == '#313131'}"
      >
        <button class="icobutton icobutton--dislike" ref="elDislike" :class="{active: isDislike}">
          <span class="fa fa-thumbs-down fa-fw" ref="iconDislike" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Config from '@/config'
import mojs from '@mojs/core'
import { setTimeout } from 'timers'
import Util from '@/util'
import storage from '@/services/storage'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      isHeart: false,
      isHaha: false,
      isQuestion: false,
      isLike: false,
      isDislike: false,
      loading: false,
      debouncingReaction: false,
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
    }),
  },
  mounted() {
    this.initAnimocon()
    const slideId = this.$store.state.slide.id
    const presentationId = this.$store.state.presentation.id
    const reactions = storage.getValueByPresentation(presentationId, 'reactions', [])
    const matchReaction = reactions.find((reaction) => reaction.slideId === slideId)

    if (!matchReaction) return

    if (matchReaction.type === 'heart') {
      this.$refs.elHeart.style.color = '#F35186'
    }

    if (matchReaction.type === 'haha') {
      this.$refs.elHaha.style.color = '#FFC700'
    }

    if (matchReaction.type === 'like') {
      this.$refs.elLike.style.color = '#28C270'
    }

    if (matchReaction.type === 'dislike') {
      this.$refs.elDislike.style.color = '#FF6767'
    }
  },
  methods: {
    resetAnimation(el) {
      const arr = el.querySelectorAll('[data-name="mojs-shape"]')
      el.isLoading = true
      setTimeout(() => {
        arr.forEach((item) => {
          item.style.transform = 'scale(0)'
        })
      }, 500)
    },
    async reaction(type, el) {
      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      const slideId = this.$store.state.slide.id
      const presentationId = this.$store.state.presentation.id
      if (this.debouncingReaction) return
      this.debouncingReaction = true
      setTimeout(() => {
        this.debouncingReaction = false
        const arr = this.$el.querySelectorAll('.item-reaction button')
        arr.forEach((item) => {
          if (item.classList[1] != el.classList[1]) {
            item.style.color = null
          }
        })
        const reactions = storage.getValueByPresentation(presentationId, 'reactions', [])
        const matchReaction = reactions.find((reaction) => reaction.slideId === slideId)

        if (!matchReaction) {
          const newReaction = { type, slideId }
          const params = {
            accessCode: this.$store.state.presentation.uniqueAccessCode,
            id: this.$store.state.slide.id,
            reactionType: type,
            slideId: this.$store.state.slide.id,
            presentationId: this.$store.state.presentation.id,
            audience: this.audienceId,
          }
          this.$http.post(Config.api.reaction, params).then(
            () => {},
            () => {},
          )
          reactions.push(newReaction)
          storage.setValueByPresentation(presentationId, 'reactions', reactions)
        } else {
          if (matchReaction.type === type) {
            if (this.loading) return
            this.loading = true
            setTimeout(() => {
              this.loading = false
            }, 200)
            const payload = {
              accessCode: this.$store.state.presentation.uniqueAccessCode,
              fake: true,
              id: this.$store.state.slide.id,
              reactionType: type,
              slideId: this.$store.state.slide.id,
              presentationId: this.$store.state.presentation.id,
              audience: this.audienceId,
            }
            if (type === 'heart') {
              payload.isHeart = true
            }
            if (type === 'haha') {
              payload.isHaha = true
            }
            if (type === 'question') {
              payload.isQuestion = true
            }
            if (type === 'like') {
              payload.isLike = true
            }
            if (type === 'dislike') {
              payload.isDislike = true
            }
            this.$http.post(Config.api.reaction, payload).then(
              () => {},
              () => {},
            )
            return
          }
          const params = {
            accessCode: this.$store.state.presentation.uniqueAccessCode,
            id: this.$store.state.slide.id,
            reactionType: type,
            oldReactionType: matchReaction.type,
            slideId: this.$store.state.slide.id,
            presentationId: this.$store.state.presentation.id,
            audience: this.audienceId,
          }

          this.$http.post(Config.api.reaction, params).then(
            () => {},
            () => {},
          )

          const newReactions = reactions.map((reaction) => {
            return reaction.slideId === slideId ? { type, slideId } : reaction
          })
          storage.setValueByPresentation(presentationId, 'reactions', newReactions)
        }
        Util.gaTrackEvent('Reaction', 'select reaction', type)
      }, 1000)
    },
    initAnimocon() {
      const selfComponent = this
      // taken from mo.js demos
      function isIOSSafari() {
        const { userAgent } = window.navigator
        return userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)
      }

      // taken from mo.js demos
      function isTouch() {
        const isIETouch = navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
        return [].indexOf.call(window, 'ontouchstart') >= 0 || isIETouch
      }

      // taken from mo.js demos
      const isIOS = isIOSSafari()
      const clickHandler = isIOS || isTouch() ? 'touchstart' : 'click'

      function extend(a, b) {
        // eslint-disable-next-line no-restricted-syntax
        for (const key in b) {
          // eslint-disable-next-line no-prototype-builtins
          if (b.hasOwnProperty(key)) {
            a[key] = b[key]
          }
        }
        return a
      }

      function Animocon(el, options) {
        this.el = el
        this.options = extend({}, this.options)
        extend(this.options, options)

        this.checked = false

        this.timeline = new mojs.Timeline()

        for (let i = 0, len = this.options.tweens.length; i < len; ++i) {
          this.timeline.add(this.options.tweens[i])
        }

        const self = this
        this.el.addEventListener(clickHandler, () => {
          self.options.onCheck()
          self.timeline.replay()
          self.checked = !self.checked
        })
      }

      Animocon.prototype.options = {
        tweens: [new mojs.Burst({})],
        onCheck() {
          return false
        },
        onUnCheck() {
          return false
        },
      }

      // Icon Heart
      const el14 = this.$refs.elHeart
      const el14span = this.$refs.iconHeart

      new Animocon(el14, {
        tweens: [
          // ring animation
          new mojs.Shape({
            parent: el14,
            duration: 750,
            type: 'circle',
            radius: { 0: 40 },
            fill: 'transparent',
            stroke: '#F35186',
            strokeWidth: { 35: 0 },
            opacity: 0.2,
            top: '45%',
            easing: mojs.easing.bezier(0, 1, 0.5, 1),
          }),
          new mojs.Shape({
            parent: el14,
            duration: 500,
            delay: 100,
            type: 'circle',
            radius: { 0: 20 },
            fill: 'transparent',
            stroke: '#F35186',
            strokeWidth: { 5: 0 },
            opacity: 0.2,
            x: 40,
            y: -60,
            easing: mojs.easing.sin.out,
          }),
          new mojs.Shape({
            parent: el14,
            duration: 500,
            delay: 180,
            type: 'circle',
            radius: { 0: 10 },
            fill: 'transparent',
            stroke: '#F35186',
            strokeWidth: { 5: 0 },
            opacity: 0.5,
            x: -10,
            y: -80,
            isRunLess: true,
            easing: mojs.easing.sin.out,
          }),
          new mojs.Shape({
            parent: el14,
            duration: 800,
            delay: 240,
            type: 'circle',
            radius: { 0: 20 },
            fill: 'transparent',
            stroke: '#F35186',
            strokeWidth: { 5: 0 },
            opacity: 0.3,
            x: -70,
            y: -10,
            easing: mojs.easing.sin.out,
          }),
          new mojs.Shape({
            parent: el14,
            duration: 800,
            delay: 240,
            type: 'circle',
            radius: { 0: 20 },
            fill: 'transparent',
            stroke: '#F35186',
            strokeWidth: { 5: 0 },
            opacity: 0.4,
            x: 80,
            y: -50,
            easing: mojs.easing.sin.out,
          }),
          new mojs.Shape({
            parent: el14,
            duration: 1000,
            delay: 300,
            type: 'circle',
            radius: { 0: 15 },
            fill: 'transparent',
            stroke: '#F35186',
            strokeWidth: { 5: 0 },
            opacity: 0.2,
            x: 20,
            y: -100,
            easing: mojs.easing.sin.out,
          }),
          new mojs.Shape({
            parent: el14,
            duration: 600,
            delay: 330,
            type: 'circle',
            radius: { 0: 25 },
            fill: 'transparent',
            stroke: '#F35186',
            strokeWidth: { 5: 0 },
            opacity: 0.4,
            x: -40,
            y: -90,
            easing: mojs.easing.sin.out,
          }),
          // icon scale animation
          new mojs.Tween({
            duration: 1200,
            easing: mojs.easing.ease.out,
            onUpdate(progress) {
              if (progress > 0.3) {
                const elasticOutProgress = mojs.easing.elastic.out(
                  1.43 * progress - 0.43,
                )
                el14span.style.WebkitTransform = el14span.style.transform =
                  `scale3d(${
                    elasticOutProgress
                  },${
                    elasticOutProgress
                  },1)`
              } else {
                el14span.style.WebkitTransform = el14span.style.transform =
                  'scale3d(0,0,1)'
              }
            },
          }),
        ],
        onCheck() {
          selfComponent.reaction('heart', el14)
          selfComponent.resetAnimation(el14)
          el14.style.color = '#F35186'
        },
      })

      // Icon Haha

      const el9 = this.$refs.elHaha
      const el9span = this.$refs.iconHaha
      el9span.style.WebkitTransformOrigin = el9span.style.transformOrigin =
        '-10% 50%'
      new Animocon(el9, {
        tweens: [
          // burst animation
          new mojs.Burst({
            parent: el9,
            count: 6,
            radius: { 40: 90 },
            angle: 135,
            degree: 90,
            children: {
              fill: [
                '#FFC700',
                '#DE8AA0',
                '#8AAEDE',
                '#8ADEAD',
                '#DEC58A',
                '#8AD1DE',
              ],
              scale: 1,
              radius: { 7: 0 },
              opacity: 0.6,
              duration: 1500,
              delay: 350,
              easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
            },
          }),
          // burst animation
          new mojs.Burst({
            parent: el9,
            count: 6,
            angle: 45,
            degree: -90,
            radius: { 40: 100 },
            children: {
              fill: [
                '#FFC700',
                '#DE8AA0',
                '#8AAEDE',
                '#8ADEAD',
                '#DEC58A',
                '#8AD1DE',
              ],
              scale: 1,
              radius: { 7: 0 },
              opacity: 0.6,
              duration: 1500,
              delay: 550,
              easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
            },
          }),
          // ring animation
          new mojs.Shape({
            parent: el9,
            radius: { 0: 50 },
            fill: 'transparent',
            stroke: '#FFC700',
            strokeWidth: { 35: 0 },
            opacity: 0.6,
            duration: 750,
            easing: mojs.easing.bezier(0, 1, 0.5, 1),
          }),
          // ring animation
          new mojs.Shape({
            parent: el9,
            radius: { 0: 50 },
            fill: 'transparent',
            stroke: '#FFC700',
            strokeWidth: { 35: 0 },
            opacity: 0.6,
            duration: 750,
            delay: 200,
            easing: mojs.easing.bezier(0, 1, 0.5, 1),
          }),
          // icon scale animation
          new mojs.Tween({
            duration: 1500,
            onUpdate(progress) {
              if (progress > 0.3) {
                const elasticOutProgress = mojs.easing.elastic.out(
                  1.43 * progress - 0.43,
                )
                el9span.style.WebkitTransform = el9span.style.transform =
                  `scale3d(${
                    elasticOutProgress
                  },${
                    elasticOutProgress
                  },1) rotate3d(0,0,1,${
                    90 * (1 - elasticOutProgress)
                  }deg)`
              } else {
                el9span.style.WebkitTransform = el9span.style.transform =
                  'scale3d(0,0,1)'
              }
            },
          }),
        ],
        onCheck() {
          el9.style.color = '#FFC700'
          selfComponent.reaction('haha', el9)
          selfComponent.resetAnimation(el9)
        },
      })

      // Icon Like
      const el5 = this.$refs.elLike
      const el5span = this.$refs.iconLike
      new Animocon(el5, {
        tweens: [
          // burst animation
          new mojs.Burst({
            parent: el5,
            count: 15,
            radius: { 20: 80 },
            angle: { 0: 140, easing: mojs.easing.bezier(0.1, 1, 0.3, 1) },
            children: {
              fill: '#28C270',
              radius: 20,
              opacity: 0.6,
              duration: 1500,
              easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
            },
          }),
          // icon scale animation
          new mojs.Tween({
            duration: 800,
            easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
            onUpdate(progress) {
              el5span.style.WebkitTransform = el5span.style.transform =
                `scale3d(${progress},${progress},1)`
            },
          }),
        ],
        onCheck() {
          el5.style.color = '#28C270'
          selfComponent.reaction('like', el5)
          selfComponent.resetAnimation(el5)
        },
      })

      // Icon Dislike
      const el16 = this.$refs.elDislike
      const el16span = this.$refs.iconDislike
      const opacityCurve16 = mojs.easing.path(
        'M0,0 L25.333,0 L75.333,100 L100,0',
      )
      const translationCurve16 = mojs.easing.path(
        'M0,100h25.3c0,0,6.5-37.3,15-56c12.3-27,35-44,35-44v150c0,0-1.1-12.2,9.7-33.3c9.7-19,15-22.9,15-22.9',
      )
      const squashCurve16 = mojs.easing.path(
        'M0,100.004963 C0,100.004963 25,147.596355 25,100.004961 C25,70.7741867 32.2461944,85.3230873 58.484375,94.8579105 C68.9280825,98.6531013 83.2611815,99.9999999 100,100',
      )
      new Animocon(el16, {
        tweens: [
          // burst animation (circles)
          new mojs.Burst({
            parent: el16,
            count: 6,
            radius: { 0: 150 },
            degree: 50,
            angle: -25,
            opacity: 0.3,
            children: {
              fill: '#FF6767',
              scale: 1,
              radius: { 'rand(5,15)': 0 },
              duration: 1700,
              delay: 350,
              easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
            },
          }),
          new mojs.Burst({
            parent: el16,
            count: 3,
            degree: 0,
            radius: { 80: 250 },
            angle: 180,
            children: {
              top: [45, 0, 45],
              left: [-15, 0, 15],
              shape: 'line',
              radius: { 60: 0 },
              scale: 1,
              stroke: '#FF6767',
              opacity: 0.4,
              duration: 650,
              delay: 200,
              easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
            },
          }),
          // icon scale animation
          new mojs.Tween({
            duration: 500,
            onUpdate(progress) {
              const translateProgress = translationCurve16(progress)
              const squashProgress = squashCurve16(progress)
              const scaleX = 1 - 2 * squashProgress
              const scaleY = 1 + 2 * squashProgress

              el16span.style.WebkitTransform = el16span.style.transform =
                `translate3d(0,${
                  -180 * translateProgress
                }px,0) scale3d(${
                  scaleX
                },${
                  scaleY
                },1)`

              const opacityProgress = opacityCurve16(progress)
              el16span.style.opacity = opacityProgress

              el16.style.color = progress >= 0.75 ? '#FF6767' : '#C0C1C3'
            },
          }),
        ],
        onCheck() {
          selfComponent.reaction('dislike', el16)
          selfComponent.resetAnimation(el16)
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.icobutton--haha.active {
  span {
    color: $reaction-smiley-color !important;
  }
}
.icobutton--heart.active {
  span {
    color: rgb(243, 81, 134) !important;
  }
}
.icobutton--question.active {
  span {
    color: rgb(111, 151, 247) !important;
  }
}
.icobutton--like.active {
  span {
    color: $reaction-thumbs-up-color !important;
  }
}
.icobutton--dislike.active {
  span {
    color: rgb(255, 103, 103) !important;
  }
}
.item-reaction {
  display: inline-block;
  padding: 16px 10px;
  font-size: 13px;
  position: relative;

  .item-reaction-bg {
    text-align: center;
    float: left;
    width: 58px;
    height: 58px;
    border-radius: 100%;
    .fa,
    .fas {
      line-height: 58px;
    }
    &.white {
      background-color: rgba(255, 255, 255, 0.1);
    }
    &.black {
      background-color: rgba(49, 49, 49, 0.1);
    }
  }

  span {
    cursor: pointer;
  }

  @media (max-width: 360px) {
    .item-reaction-bg {
      width: 52px;
      height: 52px;
      .fa,
      .fas {
        line-height: 52px;
      }
    }
    span {
      font-size: 25px;
    }
  }
}

.icobutton {
  .fa,
  .fas {
    padding: 0;
  }
}

.reaction {

  &.white {
    .icobutton {
      color: #fff;
    }
  }

  &.n-p {
    padding: 0 !important;
  }
}
</style>
